import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {EntityData} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";
import {PointsData} from "../points.data";

@Component({
    selector: "wbo-member-loyalty-redemption-type-single-select-column",
    templateUrl: "../../../framework/entity/edit/edit-grid/columns/single-select-column.component.html",
    providers: [
        {
            provide: ColumnComponent,
            useExisting: forwardRef(() => MemberLoyaltyRedemptionTypeSingleSelectColumnComponent),
            multi: true
        }
    ]
})
export class MemberLoyaltyRedemptionTypeSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent {
    @Input() membershipTypeField: string;

    constructor(injector: Injector) {
        super(injector);

        this.buildData([
            {label: "wbo.member-loyalty.option.accrual-redemption-type.none", value: PointsData.TYPE_NONE},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perDollar", value: PointsData.TYPE_PER_DOLLAR},
            {label: "wbo.member-loyalty.option.accrual-redemption-type.perUnit", value: PointsData.TYPE_PER_UNIT_AT_ANY_PRICE}
        ]);
    }

    override getClearSelectionOptionLabel(entity: EntityData<any>): string {
        return this.getPlaceholder(entity);
    }

    override getPlaceholder(entity: EntityData<any>): string {
        if (!entity[this.membershipTypeField]) {
            return undefined;
        } else if (entity[this.membershipTypeField].membershipTypeId == undefined) {
            return "wbo.member-loyalty.option.accrual-redemption-type.asPerMembershipType";
        } else {
            return "wbo.member-loyalty.option.accrual-redemption-type.productDefault";
        }
    }
}
